export type PaymentMethod = 'CREDIT_CARD' | 'DIRECT_DEBIT';

export type RepairAction = keyof typeof RepairActionEnum;

export const RepairActionEnum = {
  REQUEST_REPAIR: 'REQUEST_REPAIR',
  BOOK_ENGINEER: 'BOOK_ENGINEER',
  INCOMPLETE_FORM: 'INCOMPLETE_FORM',
  TRACK_REPAIR: 'TRACK_REPAIR',
  ON_HOLD: 'ON_HOLD',
  REFERRED: 'REFERRED',
  DIRECT_CALL_CENTRE: 'DIRECT_CALL_CENTRE',
  VIEW_OFFER: 'VIEW_OFFER',
  IN_WAIT: 'IN_WAIT',
  IN_WARRANTY: 'IN_WARRANTY',
  UNKNOWN: 'UNKNOWN',
  NO_ACTION: 'NO_ACTION',
  DIRECT_REFERRAL_ONLY: 'DIRECT_REFERRAL_ONLY',
  NOT_VALID: 'NOT_VALID',
} as const;

export type ClaimType = 'SERVICE' | 'REPAIR';

export type ServiceAction = keyof typeof ServiceActionEnum;

export const ServiceActionEnum = {
  REQUEST_SERVICE: 'REQUEST_SERVICE',
  INCOMPLETE_FORM: 'INCOMPLETE_FORM',
  AMEND_SERVICE: 'AMEND_SERVICE',
  BOOK_ENGINEER: 'BOOK_ENGINEER',
  DIRECT_CALL_CENTRE: 'DIRECT_CALL_CENTRE',
  NO_ACTION: 'NO_ACTION',
  IN_WAIT: 'IN_WAIT',
  IN_WARRANTY: 'IN_WARRANTY',
  UNKNOWN: 'UNKNOWN',
  DIRECT_REFERRAL_ONLY: 'DIRECT_REFERRAL_ONLY',
  NOT_VALID: 'NOT_VALID',
} as const;

export type PlanState = 'COVERED' | 'LAPSED' | 'CANCELLED' | 'RENEWAL';

export type PlanType = 'CUSTOMER' | 'LANDLORD';

export type ClaimStatus = 'OPEN' | 'CLOSED';

export type RepairPayment = 'REQUIRED' | 'OPTIONAL' | 'NO';

export type RepairPaymentType = 'EXCESS' | 'CALLOUT';
